import view from "../../views/settings";
import KTAPI, { getAllPlayers } from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import { errorMsg } from "./offscreen.controller";

import { _user, _handler, CustomDialog, Toasted, Clip, Countdown } from "../classes/index.classes";
var tempdata = {};
var imgProfile = null;
var profileCropper = null;
var previewReady = false;

var cropperOptions = {
    ready: function () {
        var clone = this.cloneNode();        
        $("#profile-img-cropper-preview").html(`<img src="${clone.src}" style="${clone.width == clone.height ? 'width:100%;' : ''}min-width: 0; min-height: 0; max-width: none; max-height: none;">`);
        previewReady = true;
        this.cropper.crop();

    },

    crop: function (event) {
        if (!previewReady) {
            return;
        }

        var data = event.detail;
        var cropper = this.cropper;
        var imageData = cropper.getImageData();
        var previewAspectRatio = data.width / data.height;
       
        var elem = document.getElementById('profile-img-cropper-preview');
        var previewImage = elem.getElementsByTagName('img').item(0);
        var previewWidth = elem.offsetWidth;
        var previewHeight = previewWidth / previewAspectRatio;
        var imageScaledRatio = data.width / previewWidth;

        elem.style.height = previewHeight + 'px';
        previewImage.style.width = imageData.naturalWidth / imageScaledRatio + 'px';
        previewImage.style.height = imageData.naturalHeight / imageScaledRatio + 'px';
        previewImage.style.marginLeft = -data.x / imageScaledRatio + 'px';
        previewImage.style.marginTop = -data.y / imageScaledRatio + 'px';
    },
    aspectRatio: 1 / 1,
    center: true,
    dragMode: 'move',
    autoCrop: true,
    autoCropArea: 1,
    restore: false,
    guides: false,
    highlight: false,
    cropBoxMovable: false,
    cropBoxResizable: false,
    toggleDragModeOnDblclick: false,

};



let settings = {
    render: () => {        
        return view;
    },
    after_render: async (data) => {
        $("body").localize();

        if(!data.hasOwnProperty('tab'))
        {
            data.tab = 'profile';
        }

        if(data.rerender == true)
        {
            tempdata = data;
            $('.settings-nav-tabs a').each(function(index, element) {
                $(this).attr("href",`user/${data.communityid}/settings/${$(this).attr("tab")}`);
            });

            if(imgProfile != null)
            {
                imgProfile.off("kt.imageinput.change");
                imgProfile.off("kt.imageinput.cancel");
                imgProfile.destroy();
                imgProfile = null;
            }
            
            //console.log("create new instance");
            //KTImageInput.createInstances();
            imgProfile = new KTImageInput(document.querySelector("#profile-setting-avatar-input"));
            
            $(".image-input-wrapper").css("background-image", `url(${tempdata.avatar})`);
            imgProfile = KTImageInput.getInstance(document.querySelector("#profile-setting-avatar-input"));
            
            $("#profile-img-cropper").attr("src", tempdata.avatar);
            previewReady = false;
            profileCropper = new Cropper(document.querySelector("#profile-img-cropper"), cropperOptions);

            $("#profile-setting-form").find("input[name='username']").val(tempdata.nickname);
            
            
            imgProfile.on("kt.imageinput.change", function(e) {
                //console.log("kt.imageinput.change event is fired", e);                
                var reader = new FileReader();
                reader.onload = function(j) {
                    
                    //$("#profile-img-cropper").attr("src", j.target.result);
                    //profileCropper = new Cropper(document.querySelector("#profile-img-cropper"), cropperOptions);
                    profileCropper.replace(j.target.result);
                    //$("#profile-setting-form").find("#profile-img-cropper")[1].remove();
                }               
                reader.readAsDataURL($("#profile-setting-form").find("input[name='avatar']")[0].files[0]);
                //if(profileCropper !== null ) profileCropper.destroy();
            });

            imgProfile.on("kt.imageinput.cancel", function(e) {
                profileCropper.replace(tempdata.avatar);
            });

            imgProfile.on("kt.imageinput.remove", function(e) {
                profileCropper.replace(tempdata.avatar);
            });

            if(tempdata.firstname) $("#profile-setting-form").find("input[name='firstname']").val(tempdata.firstname);
            if(tempdata.lastname) $("#profile-setting-form").find("input[name='lastname']").val(tempdata.lastname);
            $("#profile-setting-form").find("input[name='birthday']").val(new Date(tempdata.birthday * 1000).toISOString().slice(0, 10));
            $("#gender").val(`${data.gender}`).change();
            
        }
        //console.log("tab", data.tab);
        $(`a.settings-pill[tab="${data.tab}"]`).tab('show');
        KTScroll.init();





    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};

function getImageDataFromCropper()
{
    return new Promise((resolve, reject) => {
        if(profileCropper == null) return reject({message: "error"});
        profileCropper.getCroppedCanvas({width: 180, height: 180}).toBlob((blob) => {
            resolve({message: "done", blob: blob});
        });
    });
}

$(document).ready(function(){           
    $(document).on("shown.bs.tab", "a.settings-pill[tab]", function (e) {
        //console.log($(this).attr("tab"));
        renderSettingTab($(this).attr("tab"), tempdata);
    });    
    
    $(document).on("click", "button.sync-steam", async function (e) {
        $("#profile-setting-form").find("label[data-kt-image-input-action]").addClass("disabled");
        $("#profile-setting-form").find("button.update-avatar-username").attr("disabled", "disabled");
        $("#profile-setting-form").find("input[name='username']").attr("disabled", "disabled");
        profileCropper.disable();
        $(this).attr("disabled", "disabled");
        $(this).attr("data-kt-indicator", "on");
        const response = await KTAPI.syncMySteam();

        if(response.message == 'done')
        {            
            _handler.emit('update-user', response.ret);
        }
        
        $(this).removeAttr("data-kt-indicator");
        $(this).removeAttr("disabled");
        profileCropper.enable();
        $("#profile-setting-form").find("input[name='username']").removeAttr("disabled");
        $("#profile-setting-form").find("button.update-avatar-username").removeAttr("disabled");
        $("#profile-setting-form").find("label[data-kt-image-input-action]").removeClass("disabled");        
    });

    $(document).on("click", "button.update-avatar-username", async function (e) {
        
        $("#profile-setting-form").find("label[data-kt-image-input-action]").addClass("disabled");
        $("#profile-setting-form").find("button.sync-steam").attr("disabled", "disabled");
        $("#profile-setting-form").find("input[name='username']").attr("disabled", "disabled");
        profileCropper.disable();
        $(this).attr("disabled", "disabled");
        $(this).attr("data-kt-indicator", "on");

        let formData = new FormData();

        if($("#profile-img-cropper-preview").find("img")[0].src !== tempdata.avatar)
        {
            const imageData = await getImageDataFromCropper();
            //console.log("imageData", imageData);

            if(imageData.message == "error") {
                $(this).removeAttr("data-kt-indicator");
                return;
            }

            formData.append("avatar", imageData.blob, "blob.png");
        }

        if($("#profile-setting-form").find("input[name='username']").val() !== tempdata.nickname)
        {
            formData.append("nickname", $("#profile-setting-form").find("input[name='username']").val());
        }

        //check if formData is empty
        if(!formData.entries().next().done)
        {
            let rese = await KTAPI.updateMySettings(formData, (percentComplete) => {
                //console.log(percentComplete);
            });

            if(rese.message == 'done')
            {
                //console.log("update-user", rese.ret);
                _handler.emit('update-user', rese.ret);
            }
        }
        
        $(this).removeAttr("data-kt-indicator");
        $(this).removeAttr("disabled");
        $("#profile-setting-form").find("input[name='username']").removeAttr("disabled");
        $("#profile-setting-form").find("button.sync-steam").removeAttr("disabled");
        $("#profile-setting-form").find("label[data-kt-image-input-action]").removeClass("disabled");
        profileCropper.enable();
    });

    $(document).on("click", "button.update-personal-data", async function (e) {
        $("#profile-setting-form").find("input[name='firstname']").attr("disabled", "disabled");
        $("#profile-setting-form").find("input[name='lastname']").attr("disabled", "disabled");
        $("#profile-setting-form").find("input[name='birthday']").attr("disabled", "disabled");
        $("#gender").attr("disabled", "disabled");

        $(this).attr("disabled", "disabled");
        $(this).attr("data-kt-indicator", "on");        

        let formData = new FormData();

        if($("#profile-setting-form").find("input[name='firstname']").val() !== tempdata.firstname && $("#profile-setting-form").find("input[name='firstname']").val() !== "")
        {
            formData.append("firstname", $("#profile-setting-form").find("input[name='firstname']").val());
        }
        if($("#profile-setting-form").find("input[name='lastname']").val() !== tempdata.lastname && $("#profile-setting-form").find("input[name='lastname']").val() !== "")
        {
            formData.append("lastname", $("#profile-setting-form").find("input[name='lastname']").val());
        }             
        let unixTimestamp = (new Date($("#profile-setting-form").find("input[name='birthday']").val())).getTime() / 1000;
        if(unixTimestamp !== tempdata.birthday && unixTimestamp !== 0 && unixTimestamp !== null && unixTimestamp !== undefined && unixTimestamp !== 646185600)
        {
            formData.append("birthday", unixTimestamp);
        }
        if($("#gender").val() !== tempdata.gender)
        {
            formData.append("gender", $("#gender").val());
        }

         //check if formData is empty
        if(!formData.entries().next().done)
        {
            const response = await KTAPI.updateMySettings(formData, (percentComplete) => {
                //console.log(percentComplete);
            });
 
            //console.log(response);
            if(response.message == 'done')
            {
                //console.log("update-user", response.ret);
                _handler.emit('update-user', response.ret);
            }
        }

        //console.log("update-personal-data", unixTimestamp);
        $(this).removeAttr("data-kt-indicator");
        $(this).removeAttr("disabled");

        $("#gender").removeAttr("disabled");
        $("#profile-setting-form").find("input[name='birthday']").removeAttr("disabled");
        $("#profile-setting-form").find("input[name='lastname']").removeAttr("disabled");
        $("#profile-setting-form").find("input[name='firstname']").removeAttr("disabled");
        
    });

    $(document).on("click", ".external-handler", async function (e) {        
        // crea un codigo para que cuando se haga click aqui se abra el protocolo que se le pasa en href pero que no cambie nada de la pagina
        e.preventDefault();
        e.stopPropagation();

        $("#enrouter").attr("src", $(this).attr("href"));
        
    });

    $(document).on("show.bs.modal", ".bot-modal-code", async function (e) {
        
        navigator.clipboard.writeText($("#bot-text-code").val());
        $("#bot-code-copy-btn").trigger("click");
    });

    $(document).on("click", ".ts3-verify", async function (e) {
        
        $(this).attr("disabled", "disabled");
        const ts = await KTAPI.verifyTS();
        if(ts.message == 'done')
        {

            $(".ts3-btn-cont").empty().append(`<div class="notice d-flex bg-light-success rounded border-success border border-dashed mb-9 p-6">
            <!--begin::Icon-->
                    <i class="fad fa-info-circle fs-2tx text-success me-4"></i>        <!--end::Icon-->
                
                <!--begin::Wrapper-->
                <div class="d-flex flex-stack flex-grow-1 ">
                                <!--begin::Content-->
                        <div class="ts3-verifiying-msg fw-semibold">
                                                <h4 class="text-gray-900 fw-bold fs-6" data-i18n="[html]settings.tab_ts3_verifying_a">You have <span class="ts3-timer"></span> seconds to enter the verification channel, then it will be deleted and the process will be cancelled.</h4>
                            
                                                <div class="fs-7 text-gray-700">
                                                    <p class="mb-0"><span class="text-success" data-i18n="settings.tab_ts3_verifying_channel">Verification channel:</span> <span class="text-white">${ts.ts.channelName}</span></p>
                                                    <p class=""><span class="text-success" data-i18n="settings.tab_ts3_verifying_pass">Password:</span> <span class="text-white">${ts.ts.password}</span> <i class="cursor-pointer fad fa-copy clip text-gray-800 fs-4" data-clipboard-text="${ts.ts.password}" i18n-label="example.copied_text"></i></p>
                                                </div>
                                        </div>
                        <!--end::Content-->
                    
                        </div>
                <!--end::Wrapper-->  
            </div>`).localize();
            let count = new Countdown({
                displayElement: '.ts3-timer',
                seconds: 45,
            });
            count.start();
        }
    });
});

export const settingsSocket = (socket) => {
    
    socket.on("settings_bot", async (data) => {        
        if(data.isBotFriend !== undefined)
        {
            if(data.isBotFriend == true)
            {
                $(".steambot-no").addClass("d-none");
                $(".steambot-yes").removeClass("d-none");
            }
            else
            {
                const blink = await KTAPI.getBotLink();
                if(blink.message == 'done') $("#bot-quick-link").attr("href", blink.inviteLink);

                const clipboardBtns = document.querySelectorAll('.copy-clipboard');
                clipboardBtns.forEach(function(btn) {
                    const clipboard = new ClipboardJS(btn);
                    
                    clipboard.on('success', function(e) {
                        const element = e.trigger;
                        if (element.tagName === 'BUTTON') {
                            const originalHtml = element.innerHTML;
                            element.innerHTML = 'Copied';
                            setTimeout(function() {
                            element.innerHTML = originalHtml;
                            }, 3000);
                            e.clearSelection();
                        }
                    });

                    clipboard.on('error', function(e) {
                        //console.log('Failed to copy to clipboard!');
                    });
                });

                $(".steambot-yes").addClass("d-none");
                $(".steambot-no").removeClass("d-none");
            }
        }
    });

    socket.on("ts3-verification-success", async (data) => {
        $(".ts3-steps").addClass("d-flex justify-content-center").html(`<button class="btn btn-lg text-success border-success w-300px h-65px bg-gray-100 bgi-no-repeat bgi-size-cover btn-icon-success" style="background: url('assets/media/misc/ts.png');background-size: 120% auto;background-repeat: no-repeat;background-origin: 10px;background-position-x: -20px;background-position-y: -64px;"><i class="fad fa-check-circle fs-3"></i> <span class="" data-i18n="settings.tab_ts3_already_linked">Your account is already linked to TS3</span></button>`).localize();
        let div = `<div data-i18n="settings.tab_ts3_success"></div>`;
        div = $(div).localize().text();
        Toasted.showSuccess(div);
    });

    socket.on("ts3-verification-fail", async (data) => {
        errorDlg('ts3_verification_fail');
        $(".ts3-btn-cont").html(`<button class="btn btn-lg btn-light-info btn-active-info btn-active-color-gray-200 w-300px h-65px bg-white bgi-no-repeat bgi-size-cover ts3-verify" style="background: url('assets/media/misc/ts.png');background-size: 120% auto;background-repeat: no-repeat;background-origin: 10px;background-position-x: -20px;background-position-y: -64px;" data-i18n="[html]settings.tab_ts3_start"><i class="fab fa-link fs-5"></i> <span data-i18n="settings.tab_ts3_start">Start link process</span></button>`).localize();
    });

    socket.on("ts3-verification-timeout", async (data) => {
        $(".ts3-btn-cont").html(`<button class="btn btn-lg btn-light-info btn-active-info btn-active-color-gray-200 w-300px h-65px bg-white bgi-no-repeat bgi-size-cover ts3-verify" style="background: url('assets/media/misc/ts.png');background-size: 120% auto;background-repeat: no-repeat;background-origin: 10px;background-position-x: -20px;background-position-y: -64px;" data-i18n="[html]settings.tab_ts3_start"><i class="fab fa-link fs-5"></i> <span data-i18n="settings.tab_ts3_start">Start link process</span></button>`).localize();
        errorDlg('ts3_verification_timeout');
    });
};

async function renderSettingTab(tab,data)
{
    if(tab == 'profile')
    {
        /*if(imgProfile == null)
        {
            imgProfile = new KTImageInput($(`.settings-input-avatar[data-kt-image-input="true"]`));
        }*/
    }
    if(tab == 'account')
    {
        //console.log("account");
        $("#account-setting-form").find("input[name='accountid']").val(data.communityid);
        $("#account-setting-form").find("input[name='steamid']").val(data.steamid);
    }

    if(tab == 'steambot')
    {
        const is = await KTAPI.isBotFriend();
        
        if(is.message == 'error') return errorMsg('Bot error');        
        if(is.message == 'done')
        {
            if(is.isFriend == true)
            {
                $(".steambot-no").addClass("d-none");
                $(".steambot-yes").removeClass("d-none");
            }
            else
            {
                const blink = await KTAPI.getBotLink();
                if(blink.message == 'done') $("#bot-quick-link").attr("href", blink.inviteLink);

                const clipboardBtns = document.querySelectorAll('.copy-clipboard');
                clipboardBtns.forEach(function(btn) {
                    const clipboard = new ClipboardJS(btn);
                    
                    clipboard.on('success', function(e) {
                        const element = e.trigger;
                        if (element.tagName === 'BUTTON') {
                            const originalHtml = element.innerHTML;
                            element.innerHTML = 'Copied';
                            setTimeout(function() {
                            element.innerHTML = originalHtml;
                            }, 3000);
                            e.clearSelection();
                        }
                    });

                    clipboard.on('error', function(e) {
                        console.log('Failed to copy to clipboard!');
                    });
                });

                $(".steambot-yes").addClass("d-none");
                $(".steambot-no").removeClass("d-none");
            }
        }        
    }

    if (tab == 'teamspeak') {
        // const ts = await KTAPI.verifyTS();
        // console.log(ts);
        $(".ts3-verifiy-nickname").text(data.nickname);
        const ts = await KTAPI.getTS();
        if (ts.message == 'done') {
            $(".ts3-steps").addClass("d-flex justify-content-center").empty().html(`<button class="btn btn-lg text-success border-success w-300px h-65px bg-gray-100 bgi-no-repeat bgi-size-cover btn-icon-success" style="background: url('assets/media/misc/ts.png');background-size: 120% auto;background-repeat: no-repeat;background-origin: 10px;background-position-x: -20px;background-position-y: -64px;"><i class="fad fa-check-circle fs-3"></i> <span class="" data-i18n="settings.tab_ts3_already_linked">Your account is already linked to TS3</span></button>`).localize();
        } else {

            let div = `<div data-i18n="[html]settings.tab_ts3_steps"></div>`;
            div = $(div).localize();
            $(".ts3-steps").html(div.html());
        }
    }

    $(".d-flex .flex-column .flex-lg-row").localize();
}

_handler.on('update-user', async (data) => {
    
    if(data.hasOwnProperty('avatar'))
    {        
        tempdata.avatar = data.avatar;
        if(profileCropper !== null) profileCropper.destroy();
        profileCropper = new Cropper(document.querySelector("#profile-img-cropper"), cropperOptions);
        $(".image-input-wrapper").css("background-image", `url(${tempdata.avatar})`);
        $("#profile-img-cropper").attr("src", tempdata.avatar);
        profileCropper.replace(tempdata.avatar);
        //console.log("update-user", data);
    }
    if(data.hasOwnProperty('nickname'))
    {
        tempdata.nickname = data.nickname;
        $("#profile-setting-form").find("input[name='username']").val(tempdata.nickname);
    }
    if(data.hasOwnProperty('firstname'))
    {
        tempdata.firstname = data.firstname;
        $("#profile-setting-form").find("input[name='firstname']").val(tempdata.firstname);
    }
    if(data.hasOwnProperty('lastname'))
    {
        tempdata.lastname = data.lastname;
        $("#profile-setting-form").find("input[name='lastname']").val(tempdata.lastname);
    }
    if(data.hasOwnProperty('birthday'))
    {
        tempdata.birthday = data.birthday;
        $("#profile-setting-form").find("input[name='birthday']").val(new Date(tempdata.birthday * 1000).toISOString().slice(0, 10));
    }
    if(data.hasOwnProperty('gender'))
    {
        tempdata.gender = data.gender;
        $("#gender").val(`${data.gender}`).change();
    }
});


async function errorDlg(error) {
  
    let title = `<span class="" data-i18n="error.party.error"></span>`;
    let content = `<p class="mb-1 text-gray-800" data-i18n="error.settings.${error}"></p>`;
    let accept = `<span class="" data-i18n="error.party.close"></span>`;    

    title = $(title).localize().text();
    content = $(content).localize().text();
    accept = $(accept).localize().text();    

    // Envuelve la lógica del diálogo en una Promesa
    const dialogResult = await new Promise((resolve) => {
        const dialog1 = new CustomDialog({
            title: title,
            content: content,
            buttons: [{
                    text: accept,
                    class: 'btn btn-sm btn-danger btn-text-gray-100 btn-active-light-danger btn-active-color-danger fw-bolder',
                    callback: function () {
                        resolve('accept');
                    },
                    dismiss: true
                },                
            ],
            onHide: function () {
                
            },
            disableCloseButton: false,
            noBackdrop: false,
            verticallyCentered: true,
            scrollable: true
        });

        dialog1.show();
    });

    // Usa el resultado de la Promesa para continuar con la lógica correspondiente
    if (dialogResult === 'accept') {
        //console.log('Aceptado');
        // Lógica para manejar la aceptación
        return 1
    } else {
        //console.log('Cancelado');
        // Lógica para manejar la cancelación
        return 0;
    }
}

export default settings;